import { getCanAutoplay, hidePlayerUI, showPlayerUI } from "./video.js";

export const Bumper = {
  mounted() {
    if (this.el.dataset.autostart === "true" && getCanAutoplay()) {
      this.animateCircularTimer();
    }

    this.handleEvent("bumper_play_next", () => {
      this.resetAnimation();
      this.animateCircularTimer();
    });
    this.handleEvent("pause_bumper", () => this.pauseAnimation());
    this.handleEvent("resume_bumper", () => this.resumeAnimation());
  },
  updated() {
    if (this.el.dataset.autostart === "true") {
      this.animateCircularTimer();
    }
  },
  animateCircularTimer() {
    hidePlayerUI();

    // Find the progress circle inside the SVG
    const progressCircle = this.el.querySelector(".timer-ring-progress");
    if (!progressCircle) return;

    // Prevent multiple animations running simultaneously
    if (this.animationRunning) return;
    this.animationRunning = true;

    // The circumference of the circle (2 * PI * r, where r = 46)
    const circumference = 2 * Math.PI * 46; // ~289.027

    // Reset the animation - remove transition, set to start position
    progressCircle.style.transition = "none";
    progressCircle.style.strokeDashoffset = String(circumference);

    // Force a reflow to ensure the reset is applied
    void progressCircle.offsetWidth;

    // Re-enable transition and animate
    requestAnimationFrame(() => {
      const duration = this.el.dataset.duration || 10;
      progressCircle.style.transition = `stroke-dashoffset ${duration}s linear`;

      requestAnimationFrame(() => {
        // Animate to 0 (full circle)
        progressCircle.style.strokeDashoffset = "0";
      });
    });

    // Handle the click when transition ends
    const handleTransitionEnd = (e) => {
      // Only handle the stroke-dashoffset transition
      if (e.propertyName !== "stroke-dashoffset") return;

      progressCircle.removeEventListener("transitionend", handleTransitionEnd);
      this.animationRunning = false;

      showPlayerUI();
      // Find the clickable link/button
      const clickable = this.el.closest("a") || this.el.closest("button");
      if (clickable) {
        clickable.click();
      }
    };

    progressCircle.addEventListener("transitionend", handleTransitionEnd);
  },
  resetAnimation() {
    const progressCircle = this.el.querySelector(".timer-ring-progress");
    if (!progressCircle) return;

    const circumference = 2 * Math.PI * 46;
    progressCircle.style.transition = "none";
    progressCircle.style.strokeDashoffset = String(circumference);

    this.animationRunning = false;
    this.pausedOffset = null;
  },
  pauseAnimation() {
    const progressCircle = this.el.querySelector(".timer-ring-progress");
    if (!progressCircle) return;

    const computed = getComputedStyle(progressCircle);
    this.pausedOffset = computed.strokeDashoffset;
    progressCircle.style.transition = "none";
    progressCircle.style.strokeDashoffset = this.pausedOffset;
  },
  resumeAnimation() {
    const progressCircle = this.el.querySelector(".timer-ring-progress");
    if (!progressCircle || !this.pausedOffset) return;

    const circumference = 2 * Math.PI * 46;
    const remaining =
      (parseFloat(this.pausedOffset) / circumference) *
      (this.el.dataset.duration || 10);

    void progressCircle.offsetWidth;

    requestAnimationFrame(() => {
      progressCircle.style.transition = `stroke-dashoffset ${remaining}s linear`;
      requestAnimationFrame(() => {
        progressCircle.style.strokeDashoffset = "0";
      });
    });

    this.pausedOffset = null;
  },
};
